/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityLookalikesSslSubject
 */
export interface ControlEntityLookalikesSslSubject {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityLookalikesSslSubject
     */
    common_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityLookalikesSslSubject
     */
    distinguished_name?: string;
}

/**
 * Check if a given object implements the ControlEntityLookalikesSslSubject interface.
 */
export function instanceOfControlEntityLookalikesSslSubject(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityLookalikesSslSubjectFromJSON(json: any): ControlEntityLookalikesSslSubject {
    return ControlEntityLookalikesSslSubjectFromJSONTyped(json, false);
}

export function ControlEntityLookalikesSslSubjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityLookalikesSslSubject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'common_name': !exists(json, 'common_name') ? undefined : json['common_name'],
        'distinguished_name': !exists(json, 'distinguished_name') ? undefined : json['distinguished_name'],
    };
}

export function ControlEntityLookalikesSslSubjectToJSON(value?: ControlEntityLookalikesSslSubject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'common_name': value.common_name,
        'distinguished_name': value.distinguished_name,
    };
}

